let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ePOyH"), load("dH2J7"), load("2uoBF"), load("c6MKV"), load("4v96t")]).then(() => parcelRequire('4id39'));